var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeCloudsBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3050,
    height: 120,
    viewBox: "0 0 3050 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.485,
    y1: 1.552,
    x2: 0.487,
    y2: 0.621,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(-561 -837.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLAN_02",
    "data-name": "PLAN 02",
    transform: "translate(360.563 -28.313)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_01",
    "data-name": "CLOUD 01",
    d: "M440.832,113.658a5.076,5.076,0,0,0,4.49-7.487,22.927,22.927,0,0,0-32.713-7.928,45.813,45.813,0,0,0-58.355-20.026A58.972,58.972,0,0,0,246.288,90.276a38.193,38.193,0,0,0-37.525,14.265,17.541,17.541,0,0,0-14.371-.668c-5.167,2.044-3.593,9.785,1.965,9.785Z",
    transform: "translate(4112.9 880.907)",
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_03",
    "data-name": "CLOUD 03",
    d: "M762.969,342.565a13.326,13.326,0,0,0-6.839,1.891,17.467,17.467,0,0,0-25.034-7.365,34.9,34.9,0,0,0-62.665-17.256,37.883,37.883,0,0,0-51.031,7.706,29.125,29.125,0,0,0-36.157,10.494,13.375,13.375,0,0,0-17.075,4.28,13.41,13.41,0,0,0-16.338,2.888,5.415,5.415,0,0,0,4.135,8.94l214.692.182c5.563,0,7.6-7.477,2.711-10.136A13.324,13.324,0,0,0,762.969,342.565Z",
    transform: "translate(4886.511 634.342)",
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601",
    transform: "translate(-206 -59.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_01-2",
    "data-name": "CLOUD 01",
    d: "M440.832,113.658a5.076,5.076,0,0,0,4.49-7.487,22.927,22.927,0,0,0-32.713-7.928,45.813,45.813,0,0,0-58.355-20.026A58.972,58.972,0,0,0,246.288,90.276a38.193,38.193,0,0,0-37.525,14.265,17.541,17.541,0,0,0-14.371-.668c-5.167,2.044-3.593,9.785,1.965,9.785Z",
    transform: "translate(1176.206 916.325)",
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_03-2",
    "data-name": "CLOUD 03",
    d: "M762.969,342.565a13.326,13.326,0,0,0-6.839,1.891,17.467,17.467,0,0,0-25.034-7.365,34.9,34.9,0,0,0-62.665-17.256,37.883,37.883,0,0,0-51.031,7.706,29.125,29.125,0,0,0-36.157,10.494,13.375,13.375,0,0,0-17.075,4.28,13.41,13.41,0,0,0-16.338,2.888,5.415,5.415,0,0,0,4.135,8.94l214.692.182c5.563,0,7.6-7.477,2.711-10.136A13.324,13.324,0,0,0,762.969,342.565Z",
    transform: "translate(-65.489 634.342)",
    fill: "#ffffff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PLAN_02-2",
    "data-name": "PLAN 02",
    transform: "translate(1885.563 -28.313)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_01-3",
    "data-name": "CLOUD 01",
    d: "M440.832,113.658a5.076,5.076,0,0,0,4.49-7.487,22.927,22.927,0,0,0-32.713-7.928,45.813,45.813,0,0,0-58.355-20.026A58.972,58.972,0,0,0,246.288,90.276a38.193,38.193,0,0,0-37.525,14.265,17.541,17.541,0,0,0-14.371-.668c-5.167,2.044-3.593,9.785,1.965,9.785Z",
    transform: "translate(4112.9 880.907)",
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_03-3",
    "data-name": "CLOUD 03",
    d: "M762.969,342.565a13.326,13.326,0,0,0-6.839,1.891,17.467,17.467,0,0,0-25.034-7.365,34.9,34.9,0,0,0-62.665-17.256,37.883,37.883,0,0,0-51.031,7.706,29.125,29.125,0,0,0-36.157,10.494,13.375,13.375,0,0,0-17.075,4.28,13.41,13.41,0,0,0-16.338,2.888,5.415,5.415,0,0,0,4.135,8.94l214.692.182c5.563,0,7.6-7.477,2.711-10.136A13.324,13.324,0,0,0,762.969,342.565Z",
    transform: "translate(4886.511 634.342)",
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602",
    transform: "translate(-206 -59.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_01-4",
    "data-name": "CLOUD 01",
    d: "M440.832,113.658a5.076,5.076,0,0,0,4.49-7.487,22.927,22.927,0,0,0-32.713-7.928,45.813,45.813,0,0,0-58.355-20.026A58.972,58.972,0,0,0,246.288,90.276a38.193,38.193,0,0,0-37.525,14.265,17.541,17.541,0,0,0-14.371-.668c-5.167,2.044-3.593,9.785,1.965,9.785Z",
    transform: "translate(1176.206 916.325)",
    fill: "#ffffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_03-4",
    "data-name": "CLOUD 03",
    d: "M762.969,342.565a13.326,13.326,0,0,0-6.839,1.891,17.467,17.467,0,0,0-25.034-7.365,34.9,34.9,0,0,0-62.665-17.256,37.883,37.883,0,0,0-51.031,7.706,29.125,29.125,0,0,0-36.157,10.494,13.375,13.375,0,0,0-17.075,4.28,13.41,13.41,0,0,0-16.338,2.888,5.415,5.415,0,0,0,4.135,8.94l214.692.182c5.563,0,7.6-7.477,2.711-10.136A13.324,13.324,0,0,0,762.969,342.565Z",
    transform: "translate(-65.489 634.342)",
    fill: "#ffffff",
    opacity: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeCloudsBig);
export default __webpack_public_path__ + "static/media/theme-clouds-big.657955f0.svg";
export { ForwardRef as ReactComponent };